<div class="list-editor-tool">
  <button title="{{ config.description }}" class="fb-launch-button btn-tool tool-button">Edit List Configuration</button>

  <div class="customized shared-component-options">
    <a href="" class="button push">Push</a>
    <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
  </div>
</div>
